<template>
  <section class="w-full my-3">
    <div class="intro-y flex flex-col md:flex-row items-center">
      <h1 class="text-lg font-bold truncate mr-5">Información de la Obra - Bodegas Pharmasan</h1>
      <div class="ml-auto flex flex-col md:flex-row items-center text-theme-1 dark:text-theme-10 w-full md:w-auto">
        <Button icon="pi pi-info-circle" class="p-button-rounded p-button-info p-button-text" v-tooltip.left="'Informacion del presupuesto de la obra por fases'"/>
      </div>
    </div>
  </section>

  <!-- Componente de la fase -->
  <div v-for="(stage, index) in infoStages" :key="index">
    <stage-item
      :numberStage="stage.stage"
      :descriptionStage="stage.description"
      :subtotalStage="stage.subtotal"
      :executionValueStage="stage.value"
      :isVisible="stage.isVisible"
      :project="stage.project"
      @stageDetails="stageDetails"
    />
  </div>

</template>

<script>
import { defineAsyncComponent, onMounted, ref } from 'vue'
import listEtapas from '../../../services/etapas-bodegas/listEtapas'

export default {
  name: 'DashboardIndex',
  components: {
    stageItem: defineAsyncComponent(() => import('./components/stage'))
  },
  setup () {
    const infoStages = ref({})
    const viewData = ref(false)
    const isVisible = ref(false)

    /* Obtener el listado de las fases */
    const fetchStages = () => {
      return listEtapas({}).then(({ status, data }) => {
        infoStages.value = data.map(v => ({ ...v, isVisible: isVisible.value }))

        if (infoStages.value.length > 0) {
          viewData.value = true
        } else {
          viewData.value = true
        }
      }).catch(err => {
        console.error(err.message)
      })
    }

    /* Detalle */
    const stageDetails = (numberStage, isVisible) => {
      const arrayTest = infoStages.value.filter((item) => {
        return item.stage === numberStage
      })

      arrayTest[0].isVisible = !isVisible
    }

    onMounted(() => {
      fetchStages()
    })

    return {
      infoStages,
      isVisible,
      viewData,
      stageDetails
    }
  }
}
</script>

<style scoped>

</style>
